import {takeEvery} from 'redux-saga/effects'

import {
  DOWNLOAD_VOUCHER,
  FETCH_FEE_SETTINGS,
  GENERATE_MONTHLY_AUDIT_SUMMARY,
  GET_CLASS_FEE_PACKAGE_DETAILS,
  GET_CLASS_PARTICULARS,
  GET_FEE_HISTORY,
  GET_STUDENT_FEES,
  GET_STUDENT_PROFILE_FEE_PARTICULARS,
  PORTAL_FEE_VOUCHER_PRINTED,
} from '../../Actions/Fee/ActionTypes/ApiActionTypes'
import fetchData from '../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_FEE_HISTORY, fetchData)
  yield takeEvery(DOWNLOAD_VOUCHER, fetchData)
  yield takeEvery(PORTAL_FEE_VOUCHER_PRINTED, fetchData)
  yield takeEvery(GET_STUDENT_PROFILE_FEE_PARTICULARS, fetchData)
  yield takeEvery(GET_CLASS_FEE_PACKAGE_DETAILS, fetchData)
  yield takeEvery(GET_CLASS_PARTICULARS, fetchData)
  yield takeEvery(GENERATE_MONTHLY_AUDIT_SUMMARY, fetchData)
  yield takeEvery(GET_STUDENT_FEES, fetchData)
  yield takeEvery(FETCH_FEE_SETTINGS, fetchData)
}

export default dataSaga
